const GEO_API_URL = 'https://geo.api.gouv.fr';

export const checkPostalCode = async (postalCode: string): Promise<string[]> => {
  try {
    const response = await fetch(
      `${GEO_API_URL}/communes?codePostal=${encodeURIComponent(postalCode)}&fields=nom&format=json`
    );
    if (!response.ok) return [];
    const data = await response.json() as { nom: string }[];
    return data.map(c => c.nom);
  } catch {
    return [];
  }
};
